import axios from "axios";
import withRouter from 'components/Common/withRouter';
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Alert, Card, CardBody, Col, Container, FormFeedback, Input, Label, Row } from 'reactstrap';
import { createSelector } from "reselect";
import * as Yup from "yup";
import { default as logoDark, default as logoLight } from "../../assets/images/Aditya.png";

// action

const backendUrl = process.env.REACT_APP_BACKEND_URL;


const ForgetPasswordPage = props => {
  const location = useLocation();
  const roll_no_from_otp = location?.state?.roll_no || "";

  const navigate = useNavigate();
  document.title = "Forget Password";

  const dispatch = useDispatch();

  /** -------------------------
     FORM VALIDATION 
  -----------------------------*/
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      roll_no: roll_no_from_otp,
      password: "",
      confirmPassword: ""
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Please Enter New Password")
        .min(6, "Password must be at least 6 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
          "Must include uppercase, lowercase, number & special character"
        )
    }),
    onSubmit: async (values) => {
      await handleReset(values);
    }
  });


  /** -------------------------
     REDUX SELECTORS
  -----------------------------*/
  const selectForgotPasswordState = (state) => state.ForgetPassword;
  const ForgotPasswordProperties = createSelector(
    selectForgotPasswordState,
    (forgetPassword) => ({
      forgetError: forgetPassword.forgetError,
      forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
    })
  );

  const { forgetError, forgetSuccessMsg } = useSelector(ForgotPasswordProperties);

  /** -------------------------
      RESET PASSWORD API
  -----------------------------*/
  const handleReset = async (values) => {
    console.log(values)
    try {
      // console.log("Sending Data:", values);

      if (values.password !== values.confirmPassword) {
        alert("password and confirm password should be same");
        return true;
      }


      if (values.password === values.confirmPassword) {
        const response = await axios.post(
          `${backendUrl}reset-password`,
          {
            roll_no: values.roll_no,
            password: values.password
          }
        );
      }


      // Show success message
      alert(" Password reset successfully!");

      // Redirect after 2 seconds
      setTimeout(() => {
        navigate("/login");
      }, 1000);

      // console.log("API Response:", response.data);

    } catch (err) {
      console.log("API Error:", err);
      alert("Failed to reset password. Try again!");
    }
  };


  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="30" className="auth-logo-dark" />
                      <img src={logoLight} alt="" height="30" className="auth-logo-light" />
                    </Link>
                  </h3>

                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-3 text-center">Reset Your Password</h4>

                    {forgetError && (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    )}

                    {forgetSuccessMsg && (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    )}

                    <form className="form-horizontal mt-4" onSubmit={validation.handleSubmit}>

                      <div className="mb-3">
                        <Label htmlFor="roll_no">Roll Number</Label>
                        <Input
                          name="roll_no"
                          type="text"
                          value={validation.values.roll_no}
                          readOnly
                        />
                        {validation.touched.roll_no && validation.errors.roll_no && (
                          <FormFeedback type="invalid">{validation.errors.roll_no}</FormFeedback>
                        )}
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="password">New Password</Label>
                        <Input
                          name="password"
                          placeholder="Enter Password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password}
                          invalid={validation.touched.password && validation.errors.password ? true : false}
                        />
                        {validation.touched.password && validation.errors.password && (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="password">Confirm Password</Label>
                        <Input
                          name="confirmPassword"
                          placeholder="Enter Confirm Password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmPassword}
                          invalid={validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false}
                        />
                        {validation.touched.confirmPassword && validation.errors.confirmPassword && (
                          <FormFeedback type="invalid">{validation.errors.confirmPassword}</FormFeedback>
                        )}
                      </div>


                      <Row className="mb-3">
                        <div className="col-12 text-end">
                          <button className="btn btn-primary w-md" type="submit">
                            Reset
                          </button>
                        </div>
                      </Row>

                    </form>
                  </div>

                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p>
                  Remember It ? <Link to="/login" className="text-primary">Sign In Here</Link>
                </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
